import { render, staticRenderFns } from "./GrListTab.vue?vue&type=template&id=763fb23d&scoped=true"
import script from "./GrListTab.vue?vue&type=script&lang=js"
export * from "./GrListTab.vue?vue&type=script&lang=js"
import style0 from "./GrListTab.vue?vue&type=style&index=0&id=763fb23d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763fb23d",
  null
  
)

export default component.exports